module.exports = "/static/assets/7d580746844a0691ebbdd26ba5961c0e.png";